import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, Plus, History, LayoutDashboard, Mail } from "lucide-react";

export default function NavBar() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate("/", { replace: true });
  };

  return (
    <header className="sticky top-0 z-40 bg-[#0F1115]/95 backdrop-blur border-b border-[#333C47]">
      <div className="max-w-[1360px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/dashboard" className="flex items-center gap-3" data-testid="nav-logo">
          <div className="w-2.5 h-2.5 bg-[#6CC24A]" />
          <div className="flex items-baseline gap-2">
            <span className="font-display font-bold tracking-tight text-white">
              PULSE POINT
            </span>
            <span className="text-[#6CC24A] font-display font-bold tracking-tight">
              TRUST SCORE
            </span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          <Link
            to="/dashboard"
            data-testid="nav-dashboard"
            className="px-3 py-2 text-sm text-[#C7CBD1] hover:text-white flex items-center gap-2"
          >
            <LayoutDashboard className="h-4 w-4" /> Dashboard
          </Link>
          <Link
            to="/assessments"
            data-testid="nav-assessments"
            className="px-3 py-2 text-sm text-[#C7CBD1] hover:text-white flex items-center gap-2"
          >
            <History className="h-4 w-4" /> History
          </Link>
          <Link
            to="/digest"
            data-testid="nav-digest"
            className="px-3 py-2 text-sm text-[#C7CBD1] hover:text-white flex items-center gap-2"
          >
            <Mail className="h-4 w-4" /> Digest
          </Link>
          <Link
            to="/new"
            data-testid="nav-new-assessment"
            className="px-3 py-2 text-sm text-[#C7CBD1] hover:text-white flex items-center gap-2"
          >
            <Plus className="h-4 w-4" /> New assessment
          </Link>
        </nav>

        <div className="flex items-center gap-3">
          {user?.picture ? (
            <img
              src={user.picture}
              alt=""
              className="w-8 h-8 border border-[#333C47]"
              referrerPolicy="no-referrer"
            />
          ) : (
            <div className="w-8 h-8 bg-[#232931] border border-[#333C47] flex items-center justify-center text-xs text-white">
              {user?.name?.[0] || "U"}
            </div>
          )}
          <div className="hidden sm:block text-right">
            <div className="text-sm text-white font-medium leading-tight">
              {user?.name || "Signed in"}
            </div>
            <div className="text-[11px] text-[#C7CBD1] leading-tight truncate max-w-[180px]">
              {user?.email || ""}
            </div>
          </div>
          <button
            onClick={handleSignOut}
            data-testid="nav-signout"
            className="p-2 text-[#C7CBD1] hover:text-white border border-[#333C47] hover:bg-[#1A1F24]"
            title="Sign out"
          >
            <LogOut className="h-4 w-4" />
          </button>
        </div>
      </div>
    </header>
  );
}
